/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {ClaimProgressStepModel} from './claim-progress-step.model';

interface MatrixRef {
    column: number;
    row: number;
}

@Component({
    selector: 'app-claim-progress',
    templateUrl: './claim-progress.component.html',
    styleUrls: ['../../../styles/base.component.css', './claim-progress.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimProgressComponent implements OnInit {
    @Input() model: ClaimProgressStepModel;
    public matrix: ClaimProgressStepModel[][];
    public lastCompletedStep: MatrixRef;
    public tooltipToggle = new EventEmitter<boolean>();

    ngOnInit(): void {
        this.matrix = this.treeToMatrix(this.model);
        this.lastCompletedStep = this.getLastCompletedStep();
    }

    public tooltipPlacement(): string {
        if (this.lastCompletedStep.column === this.matrix.length - 1) {
            return 'bottom-right';
        }

        return 'bottom';
    }

    public getLastCompletedStep(): MatrixRef {
        if (this.matrix == null) {
            return null;
        }

        let currentStepColumn = 0;
        let currentStepRow = 0;

        this.matrix.forEach((column, columnIndex) => {
            column.forEach((row, rowIndex) => {
                if (row.isCompleted) {
                    currentStepColumn = columnIndex;
                    currentStepRow = rowIndex;
                }
            });
        });

        return {column: currentStepColumn, row: currentStepRow};
    }

    public treeToMatrix(
            rootNode: ClaimProgressStepModel,
            matrix: ClaimProgressStepModel[][] = null,
            columnIndex: number = 0,
            rowIndex: number = 0,
            includeNextSteps: boolean = true
    ): ClaimProgressStepModel[][] {
        if (rootNode == null) {
            return null;
        }

        if (matrix == null) {
            matrix = [];
        }

        if (matrix[columnIndex] == null) {
            matrix[columnIndex] = [];
        }

        if (includeNextSteps) {
            matrix[columnIndex][rowIndex] = rootNode;
        } else {
            matrix[columnIndex][rowIndex] = Object.assign({}, rootNode);
            delete matrix[columnIndex][rowIndex].nextSteps;
        }

        if (rootNode.nextSteps != null) {
            rootNode.nextSteps.forEach((step, siblingCount) => {
                this.treeToMatrix(step, matrix, columnIndex + 1, siblingCount);
            });
        }

        return matrix;
    }

    getTooltipCompleteTitle(progressModel: ClaimProgressStepModel): string {
        return `${progressModel.longDescription} (${progressModel.code})`;
    }
}
